import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllState = lazy(() => import("../pages/all-state"));

export const StateRouter = [
  {
    path: "/master-management/state",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllState />
          </Suspense>
        ),
      },
    ],
  },
];
